import React from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";

/**
 * A reusable modal for legal content (Privacy Policy / Terms).
 * Rendered via a portal into document.body so `position: fixed`
 * is relative to the viewport (centers correctly) and is never
 * trapped by a parent's transform/overflow/isolation.
 */
export default function LegalModal({ open, onClose, title, children }) {
  // Guard for SSR / react-snap pre-render (no document at build time)
  if (typeof document === "undefined") return null;

  return createPortal(
    <AnimatePresence>
      {open && (
        <div className="legal-portal">
          <motion.div
            className="legal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="legal-modal"
            role="dialog"
            aria-modal="true"
            aria-label={title}
            initial={{ opacity: 0, y: 40, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 40, scale: 0.98 }}
            transition={{ duration: 0.3 }}
          >
            <div className="legal-modal-header">
              <h3>{title}</h3>
              <button className="legal-close" onClick={onClose} aria-label="Close">
                ✕
              </button>
            </div>
            <div className="legal-modal-body">
              <p className="legal-scroll-hint">↓ Scroll to read the full document</p>
              {children}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body
  );
}
